import { UpdateMetadataRequestBody } from '../../../entities/remote-flash-v1/update-metadata-request-body';
import RemoteFlash from '../../../services/remote-flash';
import { FlashTabStrings } from '../../../store/bulk-device-flash/types';
import { LoginState } from '../../../store/login/types';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';

export const updateFirmwareComment = async ({
  deviceKey,
  commentsToSave,
  login,
  logTab,
  dispatch,
}: {
  deviceKey: string;
  commentsToSave: string;
  login: LoginState;
  logTab: FlashTabStrings;
  dispatch: Function;
}) => {
  const { client, envVariables } = login;
  const clientAuth: { loginId: string } | any = client?.authenticate();
  const commentsFormatted: { preFlashComment?: string } | { postFlashComment?: string } =
    logTab === FlashTabStrings.preFlash
      ? { preFlashComment: commentsToSave }
      : { postFlashComment: commentsToSave };

  const deviceData: UpdateMetadataRequestBody = {
    ...commentsFormatted,
    userId: clientAuth.loginId || '',
  };
  const remoteFlashService = new RemoteFlash(client, envVariables.remoteFlashV1BaseUrl);
  try {
    await remoteFlashService.updateFirmwareMetadata(deviceKey, deviceData);
    dispatch(
      enqueueSnackbarAction({
        message: 'Comments Updated',
        options: {
          variant: 'success',
        },
      }),
    );
    if (commentsToSave === '') return 'empty';
    return commentsToSave;
  } catch (error) {
    dispatch(
      enqueueSnackbarAction({
        message: `${error.message}`,
        options: {
          variant: 'error',
        },
      }),
    );
    return false;
  }
};
